import ListPurchaseOrders from "../../../../components/@documents/purchase_orders/ListPurchaseOrders";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function PurchaseOrdersPage() {

    return (
        <ListPurchaseOrders 
            routeType={routeTypes.admin}
        />
    )
}